import {ApiMethods, ApiServiceController, IApiExecutor} from "../../../../../../@bizkeytech/base/core";
import ApiEndpoints from "../../endpoints";
import type * as models from "./index.types.ts";
import {CancelToken} from "axios";

/**@inheritDoc*/
export class PlanningController extends ApiServiceController {

    /**@inheritDoc*/
    public constructor(executor: IApiExecutor | undefined) {
        super(executor);
    }

    /**
     * Fetches the planning session information.
     *
     * @param request           The request to fetch the planning session.
     * @param cancelToken   The abort controller that will be used to cancel the request.
     */
    public async getInformation(request: models.GetPlanningInformationRequest, cancelToken?: CancelToken): models.GetPlanningInformationResponse {
        return this.executor?.execute({
            method: ApiMethods.get,
            url: ApiEndpoints.planning.getInformation,
            params: request,
            cancelToken: cancelToken,
        });
    }

    /**
     * Builds a plan based on the provided request.
     *
     * @param request           The request to build the plan.
     * @param cancelToken   The abort controller that will be used to cancel the request.
     */
    public async buildPlan(request: models.BuildPlanRequest, cancelToken?: CancelToken): models.BuildPlanResponse {
        return this.executor?.execute({
            method: ApiMethods.post,
            url: ApiEndpoints.planning.buildPlan,
            cancelToken: cancelToken,
            data: request,
        });
    }

    /**
     * Lists all planning sessions based on the provided request.
     *
     * @param request           The request to list the planning sessions.
     * @param cancelToken   The abort controller that will be used to cancel the request.
     */
    public async listPlannings(request: models.ListPlanningsRequest, cancelToken?: CancelToken): models.ListPlanningsResponse {
        return this.executor?.execute({
            method: ApiMethods.get,
            url: ApiEndpoints.planning.list,
            cancelToken: cancelToken,
            params: request,
        });
    }

    /**
     * Deletes a planning session based on the provided request.
     *
     * @param request           The request to delete the planning session.
     * @param cancelToken   The abort controller that will be used to cancel the request.
     */
    public async deletePlanning(request: models.DeletePlanningRequest, cancelToken?: CancelToken): models.DeletePlanningResponse {
        return this.executor?.execute({
            method: ApiMethods.delete,
            url: ApiEndpoints.planning.delete,
            params: request,
            cancelToken: cancelToken,
        });
    }

    /**
     * Updates the properties of a planning session based on the provided request.
     *
     * @param request           The request to update the planning session properties.
     * @param cancelToken   The abort controller that will be used to cancel the request.
     */
    public async updatePlanningProperties(request: models.UpdatePlanningPropertiesRequest, cancelToken?: CancelToken): models.UpdatePlanningPropertiesResponse {
        return this.executor?.execute({
            method: ApiMethods.put,
            url: ApiEndpoints.planning.updatePlanningProperties,
            cancelToken: cancelToken,
            data: request,
        });
    }
}


export type * from './index.types.ts';
export default PlanningController;